/**
 * Ideally we would not need these imports.
 * Except for the ones used in blade templates. But again we should be getting rid of those too.
 */
import { Plugin } from "vue";
import ActionButton from "./components/_elements/ActionButton.vue";
import ActionLink from "./components/_elements/ActionLink.vue";
import ActionMenu from "./components/_elements/ActionMenu.vue";
import ActionMenuAction from "./components/_elements/ActionMenuAction.vue";
import ActivityList from "./components/Dashboard/Widgets/ActivityList.vue";
import ActivityListItem from "./components/Dashboard/Widgets/ActivityListItem.vue";
import AddItemToFolderModal from "./components/_elements/modals/AddItemToFolderModal.vue";
import AdminPage from "./components/Admin/Content/AdminPage.vue";
import Alert from "./components/_elements/Alert.vue";
import AlertBanner from "./components/_elements/alerts/AlertBanner.vue";
import AppData from "./components/AppData.vue";
import AppRecentActivityWidget from "./components/Dashboard/Widgets/RecentActivity/AppRecentActivityWidget.vue";
import ArticulateImage from "./components/ArticulateImage.vue";
import AssignmentGroupFields from "./components/Prep/assignments/AssignmentGroupFields.vue";
import BaseModal from "./components/_elements/modals/BaseModal.vue";
import BillingActiveSubscriptions from "./components/Account/Billing/BillingActiveSubscriptions.vue";
import BillingAddPaymentMethod from "./components/Account/Billing/BillingAddPaymentMethod.vue";
import BillingBillingInfo from "./components/Account/Billing/BillingBillingInfo.vue";
import BillingCancelPlan from "./components/Account/Billing/BillingCancelPlan.vue";
import BillingEditInfoPage from "./components/Account/Billing/BillingEditInfoPage.vue";
import BillingInvoiceHistory from "./components/Account/Billing/BillingInvoiceHistory.vue";
import BillingPage from "./components/Account/Billing/BillingPage.vue";
import BillingPaymentMethods from "./components/Account/Billing/BillingPaymentMethods.vue";
import BillingResumePlan from "./components/Account/Billing/BillingResumePlan.vue";
import BillingSection from "./components/Account/Billing/BillingSection.vue";
import BillingUpdateSubscriptionPayment from "./components/Account/Billing/BillingUpdateSubscriptionPayment.vue";
import BladeContent from "./components/BladeContent.vue";
import Categories from "./components/Prep/categories/Categories.vue";
import CategoryCreate from "./components/Prep/categories/CategoryCreate.vue";
import CourseAssessmentLock from "./components/Courses/CourseAssessmentLock.vue";
import CategoryEdit from "./components/Prep/categories/CategoryEdit.vue";
import ChartDonut from "./components/_elements/ChartDonut.vue";
import ChartLine from "./components/_elements/ChartLine.vue";
import ChatLauncherBottomRight from "./components/_elements/ChatLauncherBottomRight.vue";
import CheckoutTab from "./components/Account/Checkout/CheckoutTab.vue";
import CloverFullLogo from "./components/ui/images/CloverFullLogo.vue";
import ConceptComponent from "./components/Learn/ConceptComponent.vue";
import ConfirmDeleteModal from "./components/_elements/modals/ConfirmDeleteModal.vue";
import ConfirmDeleteSavedItemsFolderModal from "./components/_elements/modals/ConfirmDeleteSavedItemsFolderModal.vue";
import ContentEditor from "./components/_elements/ContentEditor.vue";
import ContentQuestionFeedbackCollection from "./components/Admin/Content/questions/ContentQuestionFeedbackCollection.vue";
import ContentQuestionFeedbackCollectionItem from "./components/Admin/Content/questions/ContentQuestionFeedbackCollectionItem.vue";
import ContentQuestionForm from "./components/Admin/Content/questions/ContentQuestionForm.vue";
import ContentQuestionHistoryList from "./components/Admin/Content/questions/ContentQuestionHistoryList.vue";
import ContentQuestionHistoryListItem from "./components/Admin/Content/questions/ContentQuestionHistoryListItem.vue";
import ContentQuestions from "./components/Admin/Content/questions/ContentQuestions.vue";
import ContentQuestionsList from "./components/Admin/Content/questions/ContentQuestionsList.vue";
import ContentQuestionsListItem from "./components/Admin/Content/questions/ContentQuestionsListItem.vue";
import ContentResources from "./components/Admin/Content/resources/ContentResources.vue";
import CopyAction from "./components/_elements/CopyAction.vue";
import CopyText from "./components/ui/forms/CopyText.vue";
import CouponEntry from "./components/Account/Checkout/CouponEntry.vue";
import CourseBadge from "./components/Search/CourseBadge.vue";
import CourseCard from "./components/Courses/CourseCard.vue";
import CoursePage from "./components/Admin/Content/courses/CoursePage.vue";
import CoursesPage from "./components/Admin/Content/courses/CoursesPage.vue";
import CoursesSliderContainer from "./components/Courses/CoursesSlider/CoursesSliderContainer.vue";
import CoursesTitleBar from "./components/Admin/Content/courses/CoursesTitleBar.vue";
import DashboardWidget from "./components/Dashboard/Widgets/DashboardWidget.vue";
import DataExport from "./components/_elements/DataExport.vue";
import DeleteTrashWithModal from "./components/_elements/DeleteTrashWithModal.vue";
import DismissableModal from "./components/_elements/DismissableModal.vue";
import Dropdown from "./components/_elements/Dropdown.vue";
import DropdownItem from "./components/_elements/DropdownItem.vue";
import EditCoursePage from "./components/Admin/Content/courses/EditCoursePage.vue";
import Editor from "./components/_elements/Editor.vue";
import EditorLinkModal from "./components/_elements/modals/EditorLinkModal.vue";
import EditorSourceModal from "./components/_elements/modals/EditorSourceModal.vue";
import EmailForm from "./components/Auth/EmailForm.vue";
import PasswordRules from "./components/Auth/PasswordRules.vue";
import EmptyPanel from "./components/_elements/EmptyPanel.vue";
import EmptyRouterView from "./components/_elements/EmptyRouterView.vue";
import EnableTwoFactor from "./components/Account/Security/EnableTwoFactor.vue";
import ExamCategoryItem from "./components/Prep/exam/ExamCategoryItem.vue";
import ExamFeedback from "./components/Prep/exam/ExamFeedback.vue";
import ExamQuestions from "./components/Admin/Content/exams/ExamQuestions.vue";
import ExamResultsDonut from "./components/Learn/ExamResultsDonut.vue";
import ExamScoreWidget from "./components/Learn/ExamScoreWidget.vue";
import ExamShow from "./components/Prep/exam/ExamShow.vue";
import ExamTake from "./components/Prep/exam/ExamTake.vue";
import ExtendAccessFields from "./components/Admin/Partners/ExtendAccessFields.vue";
import Fade from "./components/_elements/Fade.vue";
import FavoriteItem from "./components/Learn/FavoriteItem.vue";
import FeedbackButton from "./components/FeedbackButton.vue";
import FeedbackModal from "./components/_elements/modals/FeedbackModal.vue";
import Flashcard from "./components/Learn/Flashcard.vue";
import Flashcards from "./components/Learn/Flashcards.vue";
import FloodgateModal from "./components/Dashboard/FloodgateModal.vue";
import FullPagination from "./components/_elements/FullPagination.vue";
import GroupActionMenu from "./components/Admin/Partners/GroupActionMenu.vue";
import GroupAssignModal from "./components/_elements/modals/GroupAssignModal.vue";
import ImageBrowser from "./components/_elements/ImageBrowser.vue";
import ImageSelector from "./components/_elements/ImageSelector.vue";
import ImageUpload from "./components/_elements/images/ImageUpload.vue";
import ImageGallery from "./components/_elements/images/ImageGallery.vue";
import CourseAnnouncementModal from "./components/Dashboard/CourseAnnouncementModal.vue";
import LearnAnnouncementModal from "./components/Dashboard/LearnAnnouncementModal.vue";
import LearnCourseMap from "./components/Learn/LearnCourseMap.vue";
import LearnCourseMapModule from "./components/Learn/LearnCourseMapModule.vue";
import ResourceModalLink from "./components/Learn/ResourceModalLink.vue";
import LearnTestExamQuestionProps from "./components/Prep/exam/LearnTestExamQuestionProps.vue";
import LearnerDetailsList from "./components/Admin/Partners/LearnerDetailsList.vue";
import LessonActivityStats from "./components/Dashboard/Widgets/RecentActivity/LessonActivityStats.vue";
import LessonBadge from "./components/Search/LessonBadge.vue";
import LessonListing from "./components/Learn/LessonListing.vue";
import LessonNote from "./components/Learn/LessonNote.vue";
import LessonNotes from "./components/Learn/LessonNotes.vue";
import LessonPage from "./components/Admin/Content/lessons/LessonPage.vue";
import LessonTitleBar from "./components/Admin/Content/lessons/LessonTitleBar.vue";
import LessonViewActivityWidget from "./components/Dashboard/Widgets/RecentActivity/LessonViewActivityWidget.vue";
import LessonsPage from "./components/Admin/Content/lessons/LessonsPage.vue";
import LessonsTitleBar from "./components/Admin/Content/lessons/LessonsTitleBar.vue";
import LoadData from "./components/LoadData.vue";
import Loader from "./components/_elements/Loader.vue";
import LoadingSpinner from "./components/_elements/LoadingSpinner.vue";
import LoggerItems from "./components/Admin/Logger/LoggerItems.vue";
import LoginForm from "./components/Auth/LoginForm.vue";
import MainVueLayout from "./components/MainVueLayout.vue";
import MenuAccount from "./components/_elements/MenuAccount.vue";
import MenuSupport from "./components/_elements/MenuSupport.vue";
import MobileNav from "./components/_elements/MobileNav.vue";
import Modal from "./components/_elements/modals/Modal.vue";
import ModuleBadge from "./components/Search/ModuleBadge.vue";
import MoreButton from "./components/_elements/MoreButton.vue";
import MostRecentLessonLink from "./components/Learn/MostRecentLessonLink.vue";
import MriInteractiveImagesAnnouncementModal from "./components/Dashboard/MriInteractiveImagesAnnouncementModal.vue";
import MulticheckboxSelect from "./components/_elements/MulticheckboxSelect.vue";
import Multichoice from "./components/_elements/Multichoice.vue";
import OnboardingSurvey from "@/components/Account/OnboardingSurvey/OnboardingSurvey.vue";
import OtpInput from "./components/ui/forms/OtpInput.vue";
import OtpForm from "./components/Auth/OtpForm.vue";
import PageTitle from "./components/_elements/PageTitle.vue";
import Pagination from "./components/_elements/Pagination.vue";
import PartnerAccessCodesModal from "./components/_elements/modals/PartnerAccessCodesModal.vue";
import PartnerGroupModal from "./components/_elements/modals/PartnerGroupModal.vue";
import PartnerGroupsList from "./components/Admin/Users/PartnerGroupsList.vue";
import PauseButton from "./components/_elements/PauseButton.vue";
import PdfResource from "./components/_elements/PdfResource.vue";
import Pill from "./components/_elements/Pill.vue";
import Placeholder from "./components/_elements/Placeholder.vue";
import PlanTypeCard from "./components/Account/Checkout/PlanTypeCard.vue";
import PrepAnnouncementModal from "./components/Dashboard/PrepAnnouncementModal.vue";
import PrepAssignmentAssignedCollection from "./components/Prep/exam/PrepAssignmentAssignedCollection.vue";
import PrepAssignmentAssignedCollectionResource from "./components/Prep/exam/PrepAssignmentAssignedCollectionResource.vue";
import PrepAssignmentAssigneeModal from "./components/_elements/modals/PrepAssignmentAssigneeModal.vue";
import PrepAssignmentBuilder from "./components/Prep/exam/PrepAssignmentBuilder.vue";
import PrepAssignmentsCreatedCollection from "./components/Prep/exam/PrepAssignmentsCreatedCollection.vue";
import PrepAssignmentsCreatedCollectionResource from "./components/Prep/exam/PrepAssignmentsCreatedCollectionResource.vue";
import PrepBlueprintCollection from "./components/Prep/exam/PrepBlueprintCollection.vue";
import PrepBlueprintCollectionResource from "./components/Prep/exam/PrepBlueprintCollectionResource.vue";
import PrepCategoryBadge from "./components/Prep/categories/PrepCategoryBadge.vue";
import PrepCategoryCircle from "./components/Prep/exam/PrepCategoryCircle.vue";
import PrepCategoryCircles from "./components/Prep/exam/PrepCategoryCircles.vue";
import PrepCategoryFilter from "./components/Prep/categories/PrepCategoryFilter.vue";
import PrepCategoryReport from "./components/Prep/exam/PrepCategoryReport.vue";
import PrepCategoryReportDonut from "./components/Prep/exam/PrepCategoryReportDonut.vue";
import PrepCategoryReportModal from "./components/_elements/modals/PrepCategoryReportModal.vue";
import PrepCategorySlider from "./components/Prep/exam/PrepCategorySlider.vue";
import PrepExam from "./components/Prep/exam/PrepExam.vue";
import PrepExamBuilder from "./components/Prep/exam/PrepExamBuilder.vue";
import PrepExamCollection from "./components/Prep/exam/PrepExamCollection.vue";
import PrepExamCollectionCard from "./components/Prep/exam/PrepExamCollectionCard.vue";
import PrepExamCollectionListItem from "./components/Prep/exam/PrepExamCollectionListItem.vue";
import PrepExamCollectionResource from "./components/Prep/exam/PrepExamCollectionResource.vue";
import PrepExamFlagQuestion from "./components/Prep/exam/PrepExamFlagQuestion.vue";
import PrepExamLibraryCategoryCircle from "@/components/Prep/exam/PrepExamLibraryCategoryCircle.vue";
import PrepExamLibraryCategoryCircles from "@/components/Prep/exam/PrepExamLibraryCategoryCircles.vue";
import PrepExamLibraryCollection from "./components/Prep/exam/PrepExamLibraryCollection.vue";
import PrepExamLibraryCollectionResource from "./components/Prep/exam/PrepExamLibraryCollectionResource.vue";
import PrepExamOverview from "./components/Prep/exam/PrepExamOverview.vue";
import PrepExamOverviewContainer from "./components/Prep/exam/PrepExamOverviewContainer.vue";
import PrepExamOverviewNavigation from "./components/Prep/exam/PrepExamOverviewNavigation.vue";
import PrepExamQuestion from "./components/Prep/exam/PrepExamQuestion.vue";
import PrepExamResults from "./components/Prep/exam/PrepExamResults.vue";
import PrimaryLayout from "./components/_layout/PrimaryLayout.vue";
import PrimarySearch from "./components/_elements/PrimarySearch.vue";
import ProductEnrollmentsListModal from "./components/_elements/modals/ProductEnrollmentsListModal.vue";
import ProfilePhoto from "./components/_elements/ProfilePhoto.vue";
import ProgressBar from "./components/_elements/ProgressBar.vue";
import QuillRenderer from "./components/_elements/QuillRenderer.vue";
import RecoveryCodes from "./components/Account/Security/RecoveryCodes.vue";
import ReferenceList from "./components/Learn/ReferenceList.vue";
import RegistrationCodes from "./components/RegistrationCodes.vue";
import RevokeDataAccess from "./components/Account/RevokeDataAccess.vue";
import SavedFoldersList from "./components/Learn/SavedFoldersList.vue";
import SavedItems from "./components/Learn/SavedItems.vue";
import SavedItemsFolderModal from "./components/_elements/modals/SavedItemsFolderModal.vue";
import SavedItemsList from "./components/Learn/SavedItemsList.vue";
import ScoreData from "./components/_elements/ScoreData.vue";
import SearchAnnouncement from "./components/Search/SearchAnnouncement.vue";
import SearchButton from "./components/Search/SearchButton.vue";
import SearchDialog from "./components/Search/SearchDialog.vue";
import SearchInput from "./components/_elements/SearchInput.vue";
import SearchInputBox from "./components/Search/SearchInputBox.vue";
import SearchList from "./components/Search/SearchList.vue";
import SearchListItem from "./components/Search/SearchListItem.vue";
import SearchReveal from "./components/_elements/SearchReveal.vue";
import SearchableSelectDropdown from "./components/_elements/SearchableSelectDropdown.vue";
import SearchableSelectDropdownItem from "./components/_elements/SearchableSelectDropdownItem.vue";
import SelectAll from "./components/_elements/SelectAll.vue";
import SelectDropdown from "./components/_elements/SelectDropdown.vue";
import SelectList from "./components/_elements/SelectList.vue";
import SlugAutofill from "./components/_elements/SlugAutofill.vue";
import SidebarAdmin from "./components/_layout/SidebarAdmin.vue";
import SidebarBase from "./components/_layout/SidebarBase.vue";
import SidebarItem from "./components/_layout/SidebarItem.vue";
import SidebarMainNew from "./components/_layout/SidebarMainNew.vue";
import SidebarNavChild from "./components/_layout/SidebarNavChild.vue";
import SidebarNavItem from "./components/_layout/SidebarNavItem.vue";
import SidebarNavParent from "./components/_layout/SidebarNavParent.vue";
import SidebarNavRouterChild from "./components/_layout/SidebarNavRouterChild.vue";
import SidebarUser from "./components/_layout/SidebarUser.vue";
import SiteRibbon from "./components/_elements/SiteRibbon.vue";
import Skeleton from "./components/_elements/Skeleton.vue";
import SlideoverPanel from "./components/_elements/SlideoverPanel.vue";
import SortButton from "./components/_elements/SortButton.vue";
import SortableLink from "./components/_elements/SortableLink.vue";
import StyledModal from "./components/_elements/modals/StyledModal.vue";
import SurveyBlueprintEditor from "./components/Admin/Content/Survey/SurveyBlueprintEditor.vue";
import BundleImageField from "./components/Admin/Content/Bundles/BundleImageField.vue";
import SvgIcon from "./components/_elements/SvgIcon.vue";
import TableHeading from "./components/_elements/TableHeading.vue";
import Tabs from "./components/_elements/Tabs.vue";
import TimezoneSelect from "./components/_elements/TimezoneSelect.vue";
import TitleBar from "./components/_layout/TitleBar.vue";
import TitleBarNavChild from "./components/_layout/TitleBarNavChild.vue";
import TitleBarNavItem from "./components/_layout/TitleBarNavItem.vue";
import TitleBarRouter from "./components/_layout/TitleBarRouter.vue";
import Toast from "./components/_elements/Toast.vue";
import ToastNotification from "./components/_elements/ToastNotification.vue";
import Toaster from "./components/_elements/Toaster.vue";
import ToggleSwitch from "./components/_elements/ToggleSwitch.vue";
import ToggleVisibility from "./components/ToggleVisibility.vue";
import UpdateItem from "./components/Support/UpdateItem.vue";
import VideoProgress from "./components/Learn/VideoProgress.vue";
import VideosWidget from "./components/Learn/VideosWidget.vue";
import WaveContainer from "./components/_elements/WaveContainer.vue";
import WistiaPreviewer from "./components/_elements/WistiaPreviewer.vue";
import WistiaSimple from "./components/_elements/WistiaSimple.vue";
import WistiaVideo from "./components/_elements/WistiaVideo.vue";
import LessonPageDescription from "./components/Learn/LessonPageDescription.vue";
import InfoAlert from "./components/_elements/alerts/InfoAlert.vue";
import SimpleLayout from "./components/_layout/SimpleLayout.vue";
import RegisterPage from "@/components/Account/RegisterPage.vue";
import LoginPage from "@/components/Account/LoginPage.vue";
import NewAlert from "@/components/ui/alerts/Alert.vue";
import CoursesList from "./components/Courses/CoursesList.vue";
import CePill from "./components/Courses/CePill.vue";
import Bookmark from "./components/Courses/Bookmark.vue";
import Description from "./components/Courses/Description.vue";
import BookmarksPage from "./components/Learn/BookmarksPage.vue";
import WelcomeModal from "./components/Dashboard/WelcomeModal.vue";
import WavesBg from "./components/ui/images/WavesBg.vue";
import CEResetButton from "./components/Learn/CEResetButton.vue";
import StudentResetButton from "./components/Learn/StudentResetButton.vue";
import OffboardingSurvey from "@/components/Survey/OffboardingSurvey.vue";
import FixEnrollmentsButton from "@/components/FixEnrollmentsButton.vue";
import SyncAllEnrollmentsButton from "@/components/SyncAllEnrollmentsButton.vue";

export const VueComponents: Plugin = {
    install(app, options) {
        app.component("app-data", AppData);
        app.component("AppData", AppData);
        app.component("action-button", ActionButton);
        app.component("ActionButton", ActionButton);
        app.component("action-link", ActionLink);
        app.component("ActionLink", ActionLink);
        app.component("action-menu", ActionMenu);
        app.component("ActionMenu", ActionMenu);
        app.component("action-menu-action", ActionMenuAction);
        app.component("ActionMenuAction", ActionMenuAction);
        app.component("activity-list-item", ActivityListItem);
        app.component("ActivityListItem", ActivityListItem);
        app.component("activity-list", ActivityList);
        app.component("ActivityList", ActivityList);
        app.component("add-item-to-folder-modal", AddItemToFolderModal);
        app.component("AddItemToFolderModal", AddItemToFolderModal);
        app.component("admin", AdminPage);
        app.component("Admin", AdminPage);
        app.component("alert", Alert);
        app.component("Alert", Alert);
        app.component("AlertBanner", AlertBanner);
        app.component("alert-banner", AlertBanner);
        app.component("app-recent-activity-widget", AppRecentActivityWidget);
        app.component("AppRecentActivityWidget", AppRecentActivityWidget);
        app.component("articulate-image", ArticulateImage);
        app.component("ArticulateImage", ArticulateImage);
        app.component("assignment-group-fields", AssignmentGroupFields);
        app.component("AssignmentGroupFields", AssignmentGroupFields);
        app.component("base-modal", BaseModal);
        app.component("BaseModal", BaseModal);
        app.component(
            "billing-active-subscriptions",
            BillingActiveSubscriptions,
        );
        app.component("BillingActiveSubscriptions", BillingActiveSubscriptions);
        app.component("billing-add-payment-method", BillingAddPaymentMethod);
        app.component("BillingAddPaymentMethod", BillingAddPaymentMethod);
        app.component("billing-billing-info", BillingBillingInfo);
        app.component("BillingBillingInfo", BillingBillingInfo);
        app.component("billing-cancel-plan", BillingCancelPlan);
        app.component("BillingCancelPlan", BillingCancelPlan);
        app.component("billing-edit-info-page", BillingEditInfoPage);
        app.component("BillingEditInfoPage", BillingEditInfoPage);
        app.component("billing-invoice-history", BillingInvoiceHistory);
        app.component("BillingInvoiceHistory", BillingInvoiceHistory);
        app.component("billing-page", BillingPage);
        app.component("BillingPage", BillingPage);
        app.component("billing-payment-methods", BillingPaymentMethods);
        app.component("BillingPaymentMethods", BillingPaymentMethods);
        app.component("billing-resume-plan", BillingResumePlan);
        app.component("BillingResumePlan", BillingResumePlan);
        app.component("billing-section", BillingSection);
        app.component("BillingSection", BillingSection);
        app.component(
            "billing-update-subscription-payment",
            BillingUpdateSubscriptionPayment,
        );
        app.component(
            "BillingUpdateSubscriptionPayment",
            BillingUpdateSubscriptionPayment,
        );
        app.component("blade-content", BladeContent);
        app.component("BladeContent", BladeContent);
        app.component("categories", Categories);
        app.component("Categories", Categories);
        app.component("category-create", CategoryCreate);
        app.component("CategoryCreate", CategoryCreate);
        app.component("category-edit", CategoryEdit);
        app.component("CategoryEdit", CategoryEdit);
        app.component("chart-donut", ChartDonut);
        app.component("ChartDonut", ChartDonut);
        app.component("chart-line", ChartLine);
        app.component("ChartLine", ChartLine);
        app.component("chat-launcher-bottom-right", ChatLauncherBottomRight);
        app.component("ChatLauncherBottomRight", ChatLauncherBottomRight);
        app.component("CheckoutTab", CheckoutTab);
        app.component("clover-full-logo", CloverFullLogo);
        app.component("concept-component", ConceptComponent);
        app.component("ConceptComponent", ConceptComponent);
        app.component("confirm-delete-modal", ConfirmDeleteModal);
        app.component("ConfirmDeleteModal", ConfirmDeleteModal);
        app.component(
            "confirm-delete-saved-items-folder-modal",
            ConfirmDeleteSavedItemsFolderModal,
        );
        app.component(
            "ConfirmDeleteSavedItemsFolderModal",
            ConfirmDeleteSavedItemsFolderModal,
        );
        app.component("content-editor", ContentEditor);
        app.component("ContentEditor", ContentEditor);
        app.component(
            "content-question-feedback-collection",
            ContentQuestionFeedbackCollection,
        );
        app.component(
            "ContentQuestionFeedbackCollection",
            ContentQuestionFeedbackCollection,
        );
        app.component(
            "content-question-feedback-collection-item",
            ContentQuestionFeedbackCollectionItem,
        );
        app.component(
            "ContentQuestionFeedbackCollectionItem",
            ContentQuestionFeedbackCollectionItem,
        );
        app.component("content-question-form", ContentQuestionForm);
        app.component("ContentQuestionForm", ContentQuestionForm);
        app.component(
            "content-question-history-list",
            ContentQuestionHistoryList,
        );
        app.component("ContentQuestionHistoryList", ContentQuestionHistoryList);
        app.component(
            "content-question-history-list-item",
            ContentQuestionHistoryListItem,
        );
        app.component(
            "ContentQuestionHistoryListItem",
            ContentQuestionHistoryListItem,
        );
        app.component("content-questions", ContentQuestions);
        app.component("ContentQuestions", ContentQuestions);
        app.component("content-questions-list", ContentQuestionsList);
        app.component("ContentQuestionsList", ContentQuestionsList);
        app.component("content-questions-list-item", ContentQuestionsListItem);
        app.component("ContentQuestionsListItem", ContentQuestionsListItem);
        app.component("content-resources", ContentResources);
        app.component("ContentResources", ContentResources);
        app.component("copy-action", CopyAction);
        app.component("CopyAction", CopyAction);
        app.component("copy-text", CopyText);
        app.component("CopyText", CopyText);
        app.component("course-badge", CourseBadge);
        app.component("coupon-entry", CouponEntry);
        app.component("CouponEntry", CouponEntry);
        app.component("CourseBadge", CourseBadge);
        app.component("course-card", CourseCard);
        app.component("CourseCard", CourseCard);
        app.component("course-page", CoursePage);
        app.component("CoursePage", CoursePage);
        app.component("courses-page", CoursesPage);
        app.component("CoursesPage", CoursesPage);
        app.component("courses-slider-container", CoursesSliderContainer);
        app.component("CoursesSliderContainer", CoursesSliderContainer);
        app.component("courses-title-bar", CoursesTitleBar);
        app.component("CoursesTitleBar", CoursesTitleBar);
        app.component("dashboard-widget", DashboardWidget);
        app.component("DashboardWidget", DashboardWidget);
        app.component("data-export", DataExport);
        app.component("DataExport", DataExport);
        app.component("delete-trash-with-modal", DeleteTrashWithModal);
        app.component("DeleteTrashWithModal", DeleteTrashWithModal);
        app.component("dismissable-modal", DismissableModal);
        app.component("DismissableModal", DismissableModal);
        app.component("dropdown", Dropdown);
        app.component("Dropdown", Dropdown);
        app.component("dropdown-item", DropdownItem);
        app.component("DropdownItem", DropdownItem);
        app.component("edit-course-page", EditCoursePage);
        app.component("EditCoursePage", EditCoursePage);
        app.component("editor", Editor);
        app.component("Editor", Editor);
        app.component("editor-link-modal", EditorLinkModal);
        app.component("EditorLinkModal", EditorLinkModal);
        app.component("editor-source-modal", EditorSourceModal);
        app.component("EditorSourceModal", EditorSourceModal);
        app.component("email-form", EmailForm);
        app.component("EmailForm", EmailForm);
        app.component("empty-panel", EmptyPanel);
        app.component("EmptyPanel", EmptyPanel);
        app.component("empty-router-view", EmptyRouterView);
        app.component("EmptyRouterView", EmptyRouterView);
        app.component("EnableTwoFactor", EnableTwoFactor);
        app.component("exam-category-item", ExamCategoryItem);
        app.component("ExamCategoryItem", ExamCategoryItem);
        app.component("exam-feedback", ExamFeedback);
        app.component("ExamFeedback", ExamFeedback);
        app.component("exam-questions", ExamQuestions);
        app.component("ExamQuestions", ExamQuestions);
        app.component("exam-results-donut", ExamResultsDonut);
        app.component("ExamResultsDonut", ExamResultsDonut);
        app.component("exam-score-widget", ExamScoreWidget);
        app.component("ExamScoreWidget", ExamScoreWidget);
        app.component("exam-show", ExamShow);
        app.component("ExamShow", ExamShow);
        app.component("exam-take", ExamTake);
        app.component("ExamTake", ExamTake);
        app.component("extend-access-fields", ExtendAccessFields);
        app.component("ExtendAccessFields", ExtendAccessFields);
        app.component("fade", Fade);
        app.component("Fade", Fade);
        app.component("favorite-item", FavoriteItem);
        app.component("FavoriteItem", FavoriteItem);
        app.component("feedback-button", FeedbackButton);
        app.component("FeedbackButton", FeedbackButton);
        app.component("fix-enrollments-button", FixEnrollmentsButton);
        app.component("FixEnrollmentsButton", FixEnrollmentsButton);
        app.component("sync-all-enrollments-button", SyncAllEnrollmentsButton);
        app.component("SyncAllEnrollmentsButton", SyncAllEnrollmentsButton);
        app.component("feedback-modal", FeedbackModal);
        app.component("FeedbackModal", FeedbackModal);
        app.component("flashcard", Flashcard);
        app.component("Flashcard", Flashcard);
        app.component("flashcards", Flashcards);
        app.component("Flashcards", Flashcards);
        app.component("FloodgateModal", FloodgateModal);
        app.component("floodgate-modal", FloodgateModal);
        app.component("prep-announcement-modal", PrepAnnouncementModal);
        app.component("full-pagination", FullPagination);
        app.component("FullPagination", FullPagination);
        app.component("group-action-menu", GroupActionMenu);
        app.component("GroupActionMenu", GroupActionMenu);
        app.component("group-assign-modal", GroupAssignModal);
        app.component("GroupAssignModal", GroupAssignModal);
        app.component("image-browser", ImageBrowser);
        app.component("ImageBrowser", ImageBrowser);
        app.component("image-selector", ImageSelector);
        app.component("ImageUpload", ImageUpload);
        app.component("ImageGallery", ImageGallery);
        app.component("ImageSelector", ImageSelector);
        app.component("LearnAnnouncementModal", LearnAnnouncementModal);
        app.component(
            "course-announcement-modal",
            CourseAnnouncementModal
        );
        app.component(
            "CourseAnnouncementModal",
            CourseAnnouncementModal
        );
        app.component("learn-course-map", LearnCourseMap);
        app.component("LearnCourseMap", LearnCourseMap);
        app.component("learn-course-map-module", LearnCourseMapModule);
        app.component("LearnCourseMapModule", LearnCourseMapModule);
        app.component("resource-modal-link", ResourceModalLink);
        app.component("ResourceModalLink", ResourceModalLink);
        app.component(
            "learn-test-exam-question-props",
            LearnTestExamQuestionProps,
        );
        app.component("LearnTestExamQuestionProps", LearnTestExamQuestionProps);
        app.component("learner-details-list", LearnerDetailsList);
        app.component("LearnerDetailsList", LearnerDetailsList);

        //break
        app.component("lesson-activity-stats", LessonActivityStats);
        app.component("LessonActivityStats", LessonActivityStats);
        app.component("lesson-badge", LessonBadge);
        app.component("LessonBadge", LessonBadge);
        app.component("lesson-listing", LessonListing);
        app.component("LessonListing", LessonListing);
        app.component("lesson-note", LessonNote);
        app.component("LessonNote", LessonNote);
        app.component("lesson-notes", LessonNotes);
        app.component("LessonNotes", LessonNotes);
        app.component("lesson-page", LessonPage);
        app.component("LessonPage", LessonPage);
        app.component("lesson-title-bar", LessonTitleBar);
        app.component("LessonTitleBar", LessonTitleBar);
        app.component("lesson-view-activity-widget", LessonViewActivityWidget);
        app.component("LessonViewActivityWidget", LessonViewActivityWidget);
        app.component("lessons-page", LessonsPage);
        app.component("LessonsPage", LessonsPage);
        app.component("lessons-title-bar", LessonsTitleBar);
        app.component("LessonsTitleBar", LessonsTitleBar);
        app.component("load-data", LoadData);
        app.component("LoadData", LoadData);
        app.component("loader", Loader);
        app.component("Loader", Loader);
        app.component("loading-spinner", LoadingSpinner);
        app.component("LoadingSpinner", LoadingSpinner);
        app.component("logger-items", LoggerItems);
        app.component("LoggerItems", LoggerItems);
        app.component("login-form", LoginForm);
        app.component("LoginForm", LoginForm);
        app.component("main-vue-layout", MainVueLayout);
        app.component("MainVueLayout", MainVueLayout);
        app.component("menu-account", MenuAccount);
        app.component("MenuAccount", MenuAccount);
        app.component("menu-support", MenuSupport);
        app.component("MenuSupport", MenuSupport);
        app.component("mobile-nav", MobileNav);
        app.component("MobileNav", MobileNav);
        app.component("modal", Modal);
        app.component("Modal", Modal);
        app.component("module-badge", ModuleBadge);
        app.component("ModuleBadge", ModuleBadge);
        app.component("more-button", MoreButton);
        app.component("MoreButton", MoreButton);
        app.component("most-recent-lesson-link", MostRecentLessonLink);
        app.component("MostRecentLessonLink", MostRecentLessonLink);
        app.component(
            "mri-interactive-images-announcement-modal",
            MriInteractiveImagesAnnouncementModal
        );
        app.component(
            "MriInteractiveImagesAnnouncementModal",
            MriInteractiveImagesAnnouncementModal
        );
        app.component("multicheckbox-select", MulticheckboxSelect);
        app.component("MulticheckboxSelect", MulticheckboxSelect);
        app.component("multichoice", Multichoice);
        app.component("Multichoice", Multichoice);
        app.component("otp-input", OtpInput);
        app.component("OtpInput", OtpInput);
        app.component("otp-form", OtpForm);
        app.component("OtpForm", OtpForm);
        app.component("page-title", PageTitle);
        app.component("PageTitle", PageTitle);
        app.component("pagination", Pagination);
        app.component("Pagination", Pagination);
        app.component("partner-access-codes-modal", PartnerAccessCodesModal);
        app.component("PartnerAccessCodesModal", PartnerAccessCodesModal);
        app.component("partner-group-modal", PartnerGroupModal);
        app.component("PartnerGroupModal", PartnerGroupModal);
        app.component("partner-groups-list", PartnerGroupsList);
        app.component("PartnerGroupsList", PartnerGroupsList);
        app.component("pause-button", PauseButton);
        app.component("PauseButton", PauseButton);
        app.component("pdf-resource", PdfResource);
        app.component("PdfResource", PdfResource);
        app.component("pill", Pill);
        app.component("Pill", Pill);
        app.component("placeholder", Placeholder);
        app.component("Placeholder", Placeholder);
        app.component("plan-type-card", PlanTypeCard);
        app.component("PlanTypeCard", PlanTypeCard);
        app.component("PrepAnnouncementModal", PrepAnnouncementModal);
        app.component(
            "prep-assignment-assigned-collection",
            PrepAssignmentAssignedCollection,
        );
        app.component(
            "PrepAssignmentAssignedCollection",
            PrepAssignmentAssignedCollection,
        );
        app.component(
            "prep-assignment-assigned-collection-resource",
            PrepAssignmentAssignedCollectionResource,
        );
        app.component(
            "PrepAssignmentAssignedCollectionResource",
            PrepAssignmentAssignedCollectionResource,
        );
        app.component(
            "prep-assignment-assignee-modal",
            PrepAssignmentAssigneeModal,
        );
        app.component(
            "PrepAssignmentAssigneeModal",
            PrepAssignmentAssigneeModal,
        );
        app.component("prep-assignment-builder", PrepAssignmentBuilder);
        app.component("PrepAssignmentBuilder", PrepAssignmentBuilder);
        app.component(
            "prep-assignments-created-collection",
            PrepAssignmentsCreatedCollection,
        );
        app.component(
            "PrepAssignmentsCreatedCollection",
            PrepAssignmentsCreatedCollection,
        );
        app.component(
            "prep-assignments-created-collection-resource",
            PrepAssignmentsCreatedCollectionResource,
        );
        app.component(
            "PrepAssignmentsCreatedCollectionResource",
            PrepAssignmentsCreatedCollectionResource,
        );
        app.component("prep-blueprint-collection", PrepBlueprintCollection);
        app.component("PrepBlueprintCollection", PrepBlueprintCollection);
        app.component(
            "prep-blueprint-collection-resource",
            PrepBlueprintCollectionResource,
        );
        app.component(
            "PrepBlueprintCollectionResource",
            PrepBlueprintCollectionResource,
        );
        app.component("prep-category-badge", PrepCategoryBadge);
        app.component("PrepCategoryBadge", PrepCategoryBadge);
        app.component("prep-category-circle", PrepCategoryCircle);
        app.component("PrepCategoryCircle", PrepCategoryCircle);
        app.component("prep-category-circles", PrepCategoryCircles);
        app.component("PrepCategoryCircles", PrepCategoryCircles);
        app.component("prep-category-filter", PrepCategoryFilter);
        app.component("PrepCategoryFilter", PrepCategoryFilter);
        app.component("prep-category-report", PrepCategoryReport);
        app.component("PrepCategoryReport", PrepCategoryReport);
        app.component("prep-category-report-donut", PrepCategoryReportDonut);
        app.component("PrepCategoryReportDonut", PrepCategoryReportDonut);
        app.component("prep-category-report-modal", PrepCategoryReportModal);
        app.component("PrepCategoryReportModal", PrepCategoryReportModal);
        app.component("prep-category-slider", PrepCategorySlider);
        app.component("PrepCategorySlider", PrepCategorySlider);
        app.component("prep-exam", PrepExam);
        app.component("prep-exam-builder", PrepExamBuilder);
        app.component("PrepExamBuilder", PrepExamBuilder);
        app.component("prep-exam-collection", PrepExamCollection);
        app.component("PrepExamCollection", PrepExamCollection);
        app.component("prep-exam-collection-card", PrepExamCollectionCard);
        app.component("PrepExamCollectionCard", PrepExamCollectionCard);
        app.component(
            "prep-exam-collection-list-item",
            PrepExamCollectionListItem,
        );
        app.component("PrepExamCollectionListItem", PrepExamCollectionListItem);
        app.component(
            "prep-exam-collection-resource",
            PrepExamCollectionResource,
        );
        app.component("PrepExamCollectionResource", PrepExamCollectionResource);
        app.component("prep-exam-flag-question", PrepExamFlagQuestion);
        app.component("PrepExamFlagQuestion", PrepExamFlagQuestion);
        app.component(
            "PrepExamLibraryCategoryCircle",
            PrepExamLibraryCategoryCircle,
        );
        app.component(
            "PrepExamLibraryCategoryCircles",
            PrepExamLibraryCategoryCircles,
        );
        app.component(
            "prep-exam-library-collection",
            PrepExamLibraryCollection,
        );
        app.component("PrepExamLibraryCollection", PrepExamLibraryCollection);
        app.component(
            "prep-exam-library-collection-resource",
            PrepExamLibraryCollectionResource,
        );
        app.component(
            "PrepExamLibraryCollectionResource",
            PrepExamLibraryCollectionResource,
        );
        app.component("prep-exam-overview", PrepExamOverview);
        app.component("PrepExamOverview", PrepExamOverview);
        app.component(
            "prep-exam-overview-container",
            PrepExamOverviewContainer,
        );
        app.component("PrepExamOverviewContainer", PrepExamOverviewContainer);
        app.component(
            "prep-exam-overview-navigation",
            PrepExamOverviewNavigation,
        );
        app.component("PrepExamOverviewNavigation", PrepExamOverviewNavigation);
        app.component("prep-exam-question", PrepExamQuestion);
        app.component("PrepExamQuestion", PrepExamQuestion);
        app.component("prep-exam-results", PrepExamResults);
        app.component("PrepExamResults", PrepExamResults);
        app.component("primary-layout", PrimaryLayout);
        app.component("PrimaryLayout", PrimaryLayout);
        app.component("primary-search", PrimarySearch);
        app.component("PrimarySearch", PrimarySearch);
        app.component(
            "product-enrollments-list-modal",
            ProductEnrollmentsListModal,
        );
        app.component(
            "ProductEnrollmentsListModal",
            ProductEnrollmentsListModal,
        );
        app.component("profile-photo", ProfilePhoto);
        app.component("ProfilePhoto", ProfilePhoto);
        app.component("progress-bar", ProgressBar);
        app.component("ProgressBar", ProgressBar);
        app.component("quill-renderer", QuillRenderer);
        app.component("QuillRenderer", QuillRenderer);
        app.component("reference-list", ReferenceList);
        app.component("ReferenceList", ReferenceList);
        app.component("registration-codes", RegistrationCodes);
        app.component("RegistrationCodes", RegistrationCodes);
        app.component("RecoveryCodes", RecoveryCodes);
        app.component("recovery-codes", RecoveryCodes);
        app.component("revoke-data-access", RevokeDataAccess);
        app.component("RevokeDataAccess", RevokeDataAccess);
        app.component("saved-folders-list", SavedFoldersList);
        app.component("SavedFoldersList", SavedFoldersList);
        app.component("saved-items", SavedItems);
        app.component("SavedItems", SavedItems);
        app.component("saved-items-folder-modal", SavedItemsFolderModal);
        app.component("SavedItemsFolderModal", SavedItemsFolderModal);
        app.component("saved-items-list", SavedItemsList);
        app.component("SavedItemsList", SavedItemsList);
        app.component("score-data", ScoreData);
        app.component("ScoreData", ScoreData);
        app.component("search-announcement", SearchAnnouncement);
        app.component("SearchAnnouncement", SearchAnnouncement);
        app.component("search-button", SearchButton);
        app.component("SearchButton", SearchButton);
        app.component("search-dialog", SearchDialog);
        app.component("SearchDialog", SearchDialog);
        app.component("search-input", SearchInput);
        app.component("SearchInput", SearchInput);
        app.component("search-input-box", SearchInputBox);
        app.component("SearchInputBox", SearchInputBox);
        app.component("search-list", SearchList);
        app.component("SearchList", SearchList);
        app.component("search-list-item", SearchListItem);
        app.component("SearchListItem", SearchListItem);
        app.component("search-reveal", SearchReveal);
        app.component("SearchReveal", SearchReveal);
        app.component("searchable-select-dropdown", SearchableSelectDropdown);
        app.component("SearchableSelectDropdown", SearchableSelectDropdown);
        app.component(
            "searchable-select-dropdown-item",
            SearchableSelectDropdownItem,
        );
        app.component(
            "SearchableSelectDropdownItem",
            SearchableSelectDropdownItem,
        );
        app.component("select-all", SelectAll);
        app.component("SelectAll", SelectAll);
        app.component("select-dropdown", SelectDropdown);
        app.component("SelectDropdown", SelectDropdown);
        app.component("select-list", SelectList);
        app.component("SelectList", SelectList);
        app.component("slug-autofill", SlugAutofill);
        app.component("sidebar-admin", SidebarAdmin);
        app.component("SidebarAdmin", SidebarAdmin);
        app.component("sidebar-base", SidebarBase);
        app.component("SidebarBase", SidebarBase);
        app.component("sidebar-item", SidebarItem);
        app.component("SidebarItem", SidebarItem);
        app.component("sidebar-main-new", SidebarMainNew);
        app.component("SidebarMainNew", SidebarMainNew);
        app.component("sidebar-nav-child", SidebarNavChild);
        app.component("SidebarNavChild", SidebarNavChild);
        app.component("sidebar-nav-item", SidebarNavItem);
        app.component("SidebarNavItem", SidebarNavItem);
        app.component("sidebar-nav-parent", SidebarNavParent);
        app.component("SidebarNavParent", SidebarNavParent);
        app.component("sidebar-nav-router-child", SidebarNavRouterChild);
        app.component("SidebarNavRouterChild", SidebarNavRouterChild);
        app.component("sidebar-user", SidebarUser);
        app.component("SidebarUser", SidebarUser);
        app.component("site-ribbon", SiteRibbon);
        app.component("SiteRibbon", SiteRibbon);
        app.component("skeleton", Skeleton);
        app.component("Skeleton", Skeleton);
        app.component("slideover-panel", SlideoverPanel);
        app.component("SlideoverPanel", SlideoverPanel);
        app.component("sort-button", SortButton);
        app.component("SortButton", SortButton);
        app.component("sortable-link", SortableLink);
        app.component("SortableLink", SortableLink);
        app.component("styled-modal", StyledModal);
        app.component("StyledModal", StyledModal);
        app.component("survey-blueprint-editor", SurveyBlueprintEditor);
        app.component("SurveyBlueprintEditor", SurveyBlueprintEditor);
        app.component("bundle-image-field", BundleImageField);
        app.component("BundleImageField", BundleImageField);
        app.component("svg-icon", SvgIcon);
        app.component("SvgIcon", SvgIcon);
        app.component("table-heading", TableHeading);
        app.component("TableHeading", TableHeading);
        app.component("tabs", Tabs);
        app.component("Tabs", Tabs);
        app.component("timezone-select", TimezoneSelect);
        app.component("TimezoneSelect", TimezoneSelect);
        app.component("title-bar", TitleBar);
        app.component("TitleBar", TitleBar);
        app.component("title-bar-nav-child", TitleBarNavChild);
        app.component("TitleBarNavChild", TitleBarNavChild);
        app.component("title-bar-nav-item", TitleBarNavItem);
        app.component("TitleBarNavItem", TitleBarNavItem);
        app.component("title-bar-router", TitleBarRouter);
        app.component("TitleBarRouter", TitleBarRouter);
        app.component("toast", Toast);
        app.component("Toast", Toast);
        app.component("toast-notification", ToastNotification);
        app.component("ToastNotification", ToastNotification);
        app.component("toaster", Toaster);
        app.component("Toaster", Toaster);
        app.component("toggle-switch", ToggleSwitch);
        app.component("ToggleSwitch", ToggleSwitch);
        app.component("toggle-visibility", ToggleVisibility);
        app.component("ToggleVisibility", ToggleVisibility);
        app.component("update-item", UpdateItem);
        app.component("UpdateItem", UpdateItem);
        app.component("video-progress", VideoProgress);
        app.component("VideoProgress", VideoProgress);
        app.component("videos-widget", VideosWidget);
        app.component("VideosWidget", VideosWidget);
        app.component("wave-container", WaveContainer);
        app.component("WaveContainer", WaveContainer);
        app.component("wistia-previewer", WistiaPreviewer);
        app.component("WistiaPreviewer", WistiaPreviewer);
        app.component("wistia-simple", WistiaSimple);
        app.component("WistiaSimple", WistiaSimple);
        app.component("wistia-video", WistiaVideo);
        app.component("lesson-page-description", LessonPageDescription);
        app.component("info-alert", InfoAlert);
        app.component("simple-layout", SimpleLayout);
        app.component("course-assessment-lock", CourseAssessmentLock);
        app.component("register-page", RegisterPage);
        app.component("password-rules", PasswordRules);
        app.component("PasswordRules", PasswordRules);
        app.component("login-page", LoginPage);
        app.component("new-alert", NewAlert);
        app.component("ce-pill", CePill);
        app.component("Bookmark", Bookmark);
        app.component("Description", Description);
        app.component("bookmarks-page", BookmarksPage);
        app.component("courses-list", CoursesList);
        app.component("WelcomeModal", WelcomeModal);
        app.component("waves-bg", WavesBg);
        app.component("CEResetButton", CEResetButton);
        app.component("ce-reset-button", CEResetButton);
        app.component("student-reset-button", StudentResetButton);
        app.component("offboarding-survey", OffboardingSurvey);
    },
};
